export const ticketOptionsAdapter = (data) => {
  const { icon } = data;

  return {
    id: data.id,
    name: data.name,
    description: data.description,
    icon: icon && {
      id: icon.id,
      original: icon.original,
    },
  };
};

export const ticketAdapter = (data) => {
  const { group, count, luggage_policy, refund_policy } = data;

  return {
    id: data.id || data.ID,
    class: data.class,

    groupId: data.group_id,
    group: group && {
      id: group.id,
      name: group.name,
    },

    price: data.price, // currencies object { cad: 25.15 }
    adultPrice: data.adult_price,
    childPrice: data.child_price,
    infantPrice: data.infant_price,
    totalPrice: data.total_price,
    remains: data.remains,
    count: count && {
      key: count.key,
      color: count.color,
      count: count.count,
    },

    isSoldOut: data.is_sold_out,

    description: data.description,
    photos: data.photos?.map((photo) => ({
      id: photo.id,
      original: photo.original,
    })),
    options: data.options?.map(ticketOptionsAdapter),

    luggagePolicy: luggage_policy && {
      id: luggage_policy.id,
      description: luggage_policy.description,
      shortDescription: luggage_policy.short_description,
      items:
        luggage_policy.items &&
        luggage_policy.items.map((item) => ({
          icon: item.icon && { id: item.icon.id, original: item.icon.original },
        })),
    },
    refundPolicy: refund_policy && {
      id: refund_policy.id,
      feeRatio: refund_policy.fee_ratio,
      departsAtThreshold: refund_policy.departs_at_threshold,
      minFee: refund_policy.min_fee, // currencies object { cad: 25.15 }
    },
  };
};
